import { render, staticRenderFns } from "./ProjectDocumentNewFormFrProject.vue?vue&type=template&id=b133b9fa"
import script from "./ProjectDocumentNewFormFrProject.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentNewFormFrProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports